import { inject, Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../services/toast.service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  private authService = inject(AuthenticationService);
  toastService = inject(ToastService);
  translate = inject(TranslateService);

  router = inject(Router);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // add auth header with jwt if user is logged in and request is to the api url
    /* const isLoggedIn = this.authService.isLoggedIn();
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${this.loggedInUser?.jwtToken}` }
      });
    } */

    return next.handle(request).pipe(
      catchError((err) => {
        console.error('Global error handler trigger:', err);
        // Redirect to login and clear auth state on 401 Unauthorized
        if (err.status === 401) {
          this.authService.logout();
        } else if (!err.url?.includes('auth/me')) {
          // Show error toast for other errors (not for auth/me)
          this.toastService.openSnackbar({
            message: this.translate.instant('error.unexpectedErrorTryAgain'),
            icon: 'error',
          });
        }
        return throwError(() => err);
      })
    );
  }
}
